'use strict'

module.exports = isWin32() || isColorTerm()

function isWin32 () {
  return process.platform === 'win32'
}

function isColorTerm () {
  var termHasColor = /^screen|^xterm|^vt100|color|ansi|cygwin|linux/i
  return !!process.env.COLORTERM || termHasColor.test(process.env.TERM)
}



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/gauge/has-color.js
// module id = 2865
// module chunks = 0